import React, { useState, useEffect, use } from "react";
import {
	Box,
	Button,
	Tabs,
	Tab,
	TableContainer,
	Table,
	TableHead,
	TableRow,
	TableCell,
	TableBody,
	TextField,
	MenuItem,
	Paper,
	IconButton,
	Alert,
	Typography,
	InputAdornment,
	Switch,
	Autocomplete,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import config from "../config.json";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useUser } from "../contexts/UserContext";
import { CompressOutlined } from "@mui/icons-material";
import Tooltip from "@mui/material/Tooltip";
import Popper from "@mui/material/Popper";

const TAB_PLAN_DETAILS = 0;
const TAB_SOURCE_CONNECTION = 1;
const TAB_TARGET_CONNECTION = 2;
const TAB_CATEGORIES = 3; // New tab for Categories
const TAB_FIELD_MAPPING = 4; // Update the index for Field Mapping
const authTypes = ["Bearer", "Basic", "OAuth 2.0", "WSDL"];

// Reusable Dropdown Component
const CustomSelect = ({ value, onChange, options, placeholder }) => (
	<TextField
		select
		variant="outlined"
		size="small"
		fullWidth
		value={value}
		onChange={onChange}
		placeholder={placeholder}
	>
		{options.map((option, idx) => (
			<MenuItem key={idx} value={option}>
				{option}
			</MenuItem>
		))}
	</TextField>
);

const ConnectionDetails = () => {
	const { userId, userCustomerId } = useUser();
	const [showBearerToken, setShowBearerToken] = useState(false);
	const [showPassword, setShowPassword] = useState(false);
	const [sourceTestLoading, setSourceTestLoading] = useState(false);
	const [targetTestLoading, setTargetTestLoading] = useState(false);
	const [activeTab, setActiveTab] = useState(0);
	const [connectionId, setConnectionId] = useState("");
	const [mappingId, setMappingId] = useState([]);

	const [sourceFieldsModified, setSourceFieldsModified] = useState(false);
	const [targetFieldsModified, setTargetFieldsModified] = useState(false);
	const [sourceOptions, setSourceOptions] = useState([]);
	const [targetOptions, setTargetOptions] = useState([]);
	const [formData, setFormData] = useState({
		plan_name: "",
		source: "",
		target: "",
		sourceUrl: "",
		bearerToken: "",
		targetUrl: "",
		apiKey: "",
		username: "",
		password: "",
		authType: "",
		sourceAuthType: "",
		targetAuthType: "",
	});
	const [isCurrentTabComplete, setIsCurrentTabComplete] = useState(false);
	const [sources, setSources] = useState([]);
	const [targets, setTargets] = useState([]);

	const [tabStatus, setTabStatus] = useState({
		planDetails: false,
		sourceConnection: false,
		targetConnection: false,
		fieldMapping: false,
	});
	const [isEditMode, setIsEditMode] = useState(false);
	const [sourceConnectionVerified, setSourceConnectionVerified] =
		useState(false);
	const [targetConnectionVerified, setTargetConnectionVerified] =
		useState(false);
	const [lastTestedConnection, setLastTestedConnection] = useState(null);
	const [connectionStatus, setConnectionStatus] = useState(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const [editingPlanId, setEditingPlanId] = useState(null);
	const [successMessage, setSuccessMessage] = useState("");

	const [categories, setCategories] = useState({});
	const [extendedCategories, setExtendedCategories] = useState({});
	const [missingCategories, setMissingCategories] = useState([]);

	const [fieldMappings, setFieldMappings] = useState({});
	const [activeFieldMappingTab, setActiveFieldMappingTab] = useState("");
	const [isAnyCategorySelected, setIsAnyCategorySelected] = useState(false);
	const navigate = useNavigate();
	const location = useLocation();

	const [allData, setAllData] = useState({
		planDetails: {},
		sourceConnection: {},
		targetConnection: {},
		fieldMapping: {},
	});

	useEffect(() => {
		if (!userId) {
			handleLogout();
		}
	}, [userId, navigate]);

	const handleLogout = () => {
		localStorage.removeItem("authToken");
		localStorage.removeItem("userData");
		navigate("/login");
	};

	useEffect(() => {
		const handleBeforeUnload = (event) => {
			event.preventDefault();
			event.returnValue = "All details will be vanished.";
		};

		window.addEventListener("beforeunload", handleBeforeUnload);

		return () => {
			window.removeEventListener("beforeunload", handleBeforeUnload);
		};
	}, []);

	useEffect(() => {
		const fetchCategories = async () => {
			try {
				// if (!formData.source || !formData.target) return;

				console.log("New mode Fetching categories...");

				const sourceVal = formData?.source || "";
				const targetVal = formData?.target || "";

				console.log("sourceVal:", sourceVal);
				console.log("targetVal:", targetVal);

				await setCategoriesState(sourceVal, targetVal);
			} catch (error) {
				console.error("Error fetching categories:", error);
			}
		};

		fetchCategories();
	}, [formData.source, formData.target]); // Fetch categories when source or target changes

	const setCategoriesState = async (sourceVal, targetVal) => {
		try {
			const response = await axios.get(
				`${config.baseURL}middlewareCategory?source=${sourceVal}&target=${targetVal}`,
				{
					headers: {
						...config.headers,
					},
				}
			);

			if (response.status === 200) {
				const categoryData = response.data;

				const sourceCategories = categoryData.flatMap((item) =>
					(item.category_name || []).map((category) => category.source_categroy)
				);

				console.log("sourceCategories", {
					sourceCategories: sourceCategories,
				});
				setCategories(sourceCategories);
				setExtendedCategories(
					sourceCategories.reduce((acc, category) => {
						acc[category] = false; // Initialize all categories as disabled
						return acc;
					}, {})
				);
			} else {
				console.error("Failed to fetch categories:", response.statusText);
			}
		} catch (error) {
			console.error("Error fetching categories:", error);
		}
	};

	useEffect(() => {
		const fetchCategories = async () => {
			try {
				// if (!formData.source || !formData.target) return;

				console.log("Edit mode Fetching categories...");

				const queryParams = new URLSearchParams(location.search);
				const planId = queryParams.get("planId");

				if (!planId) return;

				const planResponse = await fetch(
					`${config.baseURL}middlewarePlans/${planId}`,
					{
						headers: {
							...config.headers,
							apikey: config.apikey,
							pkey: config.pkey,
						},
					}
				);

				if (!planResponse.ok) {
					throw new Error(`Error fetching plan: ${planResponse.statusText}`);
				}

				const planData = await planResponse.json();
				const planDetails = Array.isArray(planData) ? planData[0] : planData;

				const sourceVal = planDetails?.source || "";
				const targetVal = planDetails?.target || "";

				console.log("sourceVal:", sourceVal);
				console.log("targetVal:", targetVal);

				await setCategoriesState(sourceVal, targetVal);
			} catch (error) {
				console.error("Error fetching categories:", error);
			}
		};

		fetchCategories();
	}, [location.search]); // Fetch categories when source or target changes

	useEffect(() => {
		const fetchSources = async () => {
			try {
				console.log({ userCustomerId: userCustomerId });

				const response = await axios.get(
					`${config.baseURL}middlewareCustomers/${userCustomerId}`,
					{
						headers: {
							...config.headers,
							apikey: config.apikey,
							pkey: config.pkey,
						},
					}
				);

				const customerData = response.data[0];
				// var sourceNames = customerData.Source_List || [];
				// var targetNames = customerData.Target_List || [];

				console.log("customerData->response", response);

				const sourceNames = customerData.Source_List.map(
					(option) => option.Source_Name
				).sort((a, b) => a.localeCompare(b));

				console.log("sourceNames", sourceNames);

				const targetNames = customerData.Target_List.map(
					(option) => option.Target_Name
				).sort((a, b) => a.localeCompare(b));

				console.log("targetNames", targetNames);

				setSources(sourceNames);
				setTargets(targetNames);

				// const response2 = await fetch(`${config.baseURL}middlewareSources`, {
				// 	method: "GET",
				// 	headers: {
				// 		apikey: config.apikey,
				// 		pkey: config.pkey,
				// 	},
				// });

				// if (response2.ok) {
				// 	const data = await response2.json();
				// 	const sourceNames = data.map((item) => item.name);
				// 	// setSources(sourceNames);
				// 	console.log("Existing sources->", sourceNames);
				// } else {
				// 	console.error("Failed to fetch sources", response.statusText);
				// }
			} catch (error) {
				console.error("Error fetching sources", error);
			}
		};

		fetchSources();
	}, []);

	// useEffect(() => {
	// 	const fetchTargets = async () => {
	// 		try {
	// 			const response = await fetch(`${config.baseURL}middlewareTargets`, {
	// 				method: "GET",
	// 				headers: {
	// 					apikey: config.apikey,
	// 					pkey: config.pkey,
	// 				},
	// 			});

	// 			if (!response.ok) {
	// 				console.error(
	// 					`Failed to fetch targets: ${response.status} - ${response.statusText}`
	// 				);
	// 				return;
	// 			}

	// 			const data = await response.json();
	// 			const targetNames = data.map((item) => item.name);
	// 			setTargets(targetNames);
	// 		} catch (error) {
	// 			console.error("Error fetching targets:", error);
	// 		}
	// 	};

	// 	fetchTargets();
	// }, []);

	useEffect(() => {
		const queryParams = new URLSearchParams(location.search);
		const planId = queryParams.get("planId");

		if (planId && categories.length > 0) {
			// Ensure categories is loaded
			setEditingPlanId(planId);
			setIsEditMode(true);
			setTabStatus({
				planDetails: true,
				sourceConnection: true,
				targetConnection: true,
				fieldMapping: true,
			});
			fetchPlanDetails(planId);
		}
	}, [categories, location.search]); // Run only when categories or location.search changes

	const fetchPlanDetails = async (planId) => {
		setLoading(true);
		setError(null);

		try {
			console.log("Fetching plan details...");

			const planResponse = await fetch(
				`${config.baseURL}middlewarePlans/${planId}`,
				{
					headers: {
						...config.headers,
						apikey: config.apikey,
						pkey: config.pkey,
					},
				}
			);

			if (!planResponse.ok) {
				throw new Error(`Error fetching plan: ${planResponse.statusText}`);
			}

			const planData = await planResponse.json();
			const planDetails = Array.isArray(planData) ? planData[0] : planData;

			setFormData((prevData) => ({
				...prevData,
				plan_name: planDetails?.plan_name || "",
				source: planDetails?.source || "",
				target: planDetails?.target || "",
			}));

			const sourceVal = planDetails?.source?.toLowerCase() || "";
			const targetVal = planDetails?.target?.toLowerCase() || "";

			const planConnectionsConfig = {
				headers: {
					...config.headers,
					apikey: config.apikey,
					pkey: config.pkey,
				},
			};

			const queryParams1 = new URLSearchParams({
				query: `plan_id:${planId}`,
			}).toString();

			const connectionsResponse = await fetch(
				`${config.baseURL}middlewarePlanconnections?${queryParams1}`,
				planConnectionsConfig
			);

			if (connectionsResponse.ok) {
				const connectionsData = await connectionsResponse.json();
				setConnectionId(connectionsData[0].id);
				if (connectionsData && connectionsData.length > 0) {
					const connection = connectionsData[0];
					let username = "",
						password = "";
					if (connection?.target_api_token) {
						try {
							const decodedCredentials = atob(connection.target_api_token);
							[username, password] = decodedCredentials.split(":");
							connection.username = username;
							connection.password = password;
						} catch (e) {
							console.error("Error decoding credentials:", e);
						}
					}
					const connectorAuthTypes = {
						Intercom: "Bearer",
						Tebra: "WSDL",
						Salesforce: "OAuth 2.0",
						WSDL: "Basic", // or WSDL depending on behavior
					};
					// Set the form data based on the connection details
					setFormData((prevData) => ({
						...prevData,
						sourceUrl: connection?.source_uri || "",
						bearerToken: connection?.source_api_token || "",
						targetUrl: connection?.target_uri || "",
						apiKey: connection?.target_api_token || "",
						practiceName: connection?.other_target_details?.practiceName,
						customerKey: connection?.other_target_details?.customerKey,
						username: connection?.username || "",
						password: connection?.password || "",
						authType: "",
						sourceAuthType:
							connection?.source_auth_type ||
							connectorAuthTypes[planDetails.source] ||
							"",
						targetAuthType:
							connection?.target_auth_type ||
							connectorAuthTypes[planDetails.target] ||
							"",

						clientId: connection?.other_target_details?.clientId || "",
						clientSecret: connection?.other_target_details?.clientSecret || "",
						grantType: connection?.other_target_details?.grantType || "",
					}));

					setSourceConnectionVerified(true);
					setTargetConnectionVerified(true);
				}
			}

			// const config1 = {
			// 	method: "get",
			// 	maxBodyLength: Infinity,
			// 	url: `${config.baseURL}get-sg-middleware-mapping-objectsnew?source=${sourceVal}&target=${targetVal}&plan_mapping_category_name=${activeFieldMappingTab}`,
			// 	headers: {
			// 		...config.headers,
			// 	},
			// };

			// console.log("userId:" + userId);
			// const mappingObjectsResponse = await axios.request(config1);

			// console.log("mappingObjectsResponse->", mappingObjectsResponse);
			// const data1 = mappingObjectsResponse.data;

			// const sourceOptionsData1 = data1.sourceOptions;
			// const targetOptionsData1 = data1.targetOptions;

			// console.log("fetchPlanDetails->Source options/:", sourceOptionsData1);
			// console.log("fetchPlanDetails->Target options/:", targetOptionsData1);

			// setSourceOptions(sourceOptionsData1 || []);
			// setTargetOptions(targetOptionsData1 || []);

			const planMappingsConfig = {
				headers: {
					...config.headers,
					apikey: config.apikey,
					pkey: config.pkey,
				},
			};

			const queryParams2 = new URLSearchParams({
				query: `plan_id:${planId}`,
			}).toString();

			const mappingsResponse = await fetch(
				`${config.baseURL}middlewarePlanmappings?${queryParams2}`,
				planMappingsConfig
			);

			if (mappingsResponse.ok) {
				const mappingsData = await mappingsResponse.json();
				setMappingId((prevIds) => [
					...prevIds,
					...mappingsData.map((mapping) => mapping.id),
				]);

				const initialFieldMappings = {};
				const categoryNames = [];
				const savedCategories = [];

				console.log("categories", categories);

				categories.forEach((category) => {
					initialFieldMappings[category] = [];
				});

				mappingsData.forEach((mapping) => {
					const category = mapping.plan_mapping_category_name;
					if (!categoryNames.includes(category)) {
						categoryNames.push(category);
					}
					mapping.fieldMappings.forEach((field) => {
						const mappingObject = {
							source: field.source_field || "",
							target: field.target_field || "",
							datatype: field.target_datatype || "",
						};

						const category = mapping.plan_mapping_category_name;
						savedCategories.push(category);

						if (initialFieldMappings[category]) {
							initialFieldMappings[category].push(mappingObject);
						}
					});
				});

				const missingCategories = categories.filter(
					(category) => !categoryNames.includes(category)
				);

				setMissingCategories(missingCategories);

				missingCategories.forEach((category) => {
					initialFieldMappings[category] = [
						{
							source: "",
							target: "",
							datatype: "",
							remarks: "",
						},
					];
				});

				setExtendedCategories((prev) => {
					const updated = { ...prev };
					savedCategories.forEach((cat) => {
						updated[cat] = true;
					});
					return updated;
				});

				setFieldMappings(initialFieldMappings);
			}

			setTabStatus({
				planDetails: true,
				sourceConnection: true,
				targetConnection: true,
				fieldMapping: true,
			});
		} catch (error) {
			console.error("Error fetching plan details:", error);
			setError("Failed to load plan details. Please try again later.");
		} finally {
			setLoading(false);
		}
	};

	const handleTabChange = (event, newValue) => {
		if (newValue === TAB_FIELD_MAPPING) {
			setupDefaultFieldMappingTab();
		}
		if (isTabEnabled(newValue)) {
			setActiveTab(newValue);
			setConnectionStatus(null);
		}
	};

	const handleFieldMappingTabChangeEdit = async (newTab) => {
		setActiveFieldMappingTab(newTab);

		// Fetch dropdowns
		try {
			const response = await axios.get(
				`${
					config.baseURL
				}get-sg-middleware-mapping-objectsnew?source=${formData.source.toLowerCase()}&target=${formData.target.toLowerCase()}&plan_mapping_category_name=${newTab}`,
				{
					headers: {
						...config.headers,
					},
				}
			);

			console.log(
				"handleFieldMappingTabChangeEdit->Source options/:",
				response.data.sourceOptions
			);
			console.log(
				"handleFieldMappingTabChangeEdit->Target options/:",
				response.data.targetOptions
			);
			setSourceOptions(response.data.sourceOptions || []);
			setTargetOptions(response.data.targetOptions || []);
		} catch (error) {
			console.error("❌ Error loading dropdowns in edit tab change:", error);
		}

		// Load saved mapping if not already present
		if (!fieldMappings[newTab] || fieldMappings[newTab].length === 0) {
			try {
				const res = await axios.get(
					`${config.baseURL}middlewarePlanmappings?query=plan_id:${editingPlanId}`,
					{
						headers: {
							...config.headers,
						},
					}
				);

				const found = res.data.find(
					(item) => item.plan_mapping_category_name === newTab
				);

				if (found) {
					setFieldMappings((prev) => ({
						...prev,
						[newTab]: found.fieldMappings.map((f) => ({
							source: f.source_field || "",
							target: f.target_field || "",
							datatype: f.target_datatype || "",
							remarks: f.mapping_remarks || "",
						})),
					}));
				}
			} catch (err) {
				console.error("❌ Error loading saved mappings in edit mode:", err);
			}
		}
	};

	const loadAllSavedMappingsAndOptions = async () => {
		try {
			const mappingsResponse = await axios.get(
				`${config.baseURL}middlewarePlanmappings?query=plan_id:${editingPlanId}`,
				{
					headers: {
						...config.headers,
					},
				}
			);

			const mappingsData = mappingsResponse.data;

			console.log("mappingsData", mappingsData);
			const allFieldMappings = {};
			const mappedCategories = [];

			for (const mapping of mappingsData) {
				const category = mapping.plan_mapping_category_name;
				mappedCategories.push(category);
				allFieldMappings[category] = mapping.fieldMappings.map((field) => ({
					source: field.source_field || "",
					target: field.target_field || "",
					datatype: field.target_datatype || "",
					remarks: field.mapping_remarks || "",
				}));
			}

			setFieldMappings(allFieldMappings);
			setExtendedCategories((prev) => {
				const updated = { ...prev };
				mappedCategories.forEach((cat) => {
					updated[cat] = true;
				});
				return updated;
			});

			// ✅ Set first mapped category as default active tab
			if (mappedCategories.length > 0) {
				setActiveFieldMappingTab(mappedCategories[0]);
			}

			// Optional: also preload dropdown options for first category
			const firstCategory = mappedCategories[0];
			if (firstCategory) {
				const res = await axios.get(
					`${
						config.baseURL
					}get-sg-middleware-mapping-objectsnew?source=${formData.source.toLowerCase()}&target=${formData.target.toLowerCase()}&plan_mapping_category_name=${firstCategory}`,
					{
						headers: {
							...config.headers,
						},
					}
				);

				console.log(
					"loadAllSavedMappingsAndOptions->Source options/:",
					res.data.sourceOptions
				);
				console.log(
					"loadAllSavedMappingsAndOptions->Target options/:",
					res.data.targetOptions
				);

				setSourceOptions(res.data.sourceOptions || []);
				setTargetOptions(res.data.targetOptions || []);
			}
		} catch (err) {
			console.error("❌ Failed to load mappings/options", err);
		}
	};
	useEffect(() => {
		if (
			isEditMode &&
			activeTab === TAB_FIELD_MAPPING &&
			editingPlanId &&
			categories.length > 0
		) {
			loadAllSavedMappingsAndOptions();
		}
	}, []);

	const handleFieldMappingTabChange = (tab) => {
		setActiveFieldMappingTab(tab);
		const fetchData = async () => {
			try {
				const config1 = {
					method: "get",
					maxBodyLength: Infinity,
					url: `${
						config.baseURL
					}get-sg-middleware-mapping-objectsnew?source=${formData.source.toLowerCase()}&target=${formData.target.toLowerCase()}&plan_mapping_category_name=${tab}`,
					headers: {
						...config.headers,
					},
				};

				const response1 = await axios.request(config1);
				const data1 = response1.data;

				const sourceOptionsData1 = data1.sourceOptions;
				const targetOptionsData1 = data1.targetOptions;

				console.log(
					"handleFieldMappingTabChange->Source options/:",
					sourceOptionsData1
				);
				console.log(
					"handleFieldMappingTabChange->Target options/:",
					targetOptionsData1
				);

				setSourceOptions(sourceOptionsData1 || []);
				setTargetOptions(targetOptionsData1 || []);
			} catch (error) {
				console.error("Error fetching mapping objects:", error);
			}
		};

		fetchData();
	};

	const connectorAuthTypes = {
		Intercom: "Bearer",
		Tebra: "Basic",
		Salesforce: "OAuth 2.0",
		WSDL: "Basic", // or "WSDL" if treated as separate
		// Add more as needed
	};

	/*const handleInputChange = (e) => {
		const { name, value } = e.target;
		setFormData((prev) => ({ ...prev, [name]: value }));

		if (name === "sourceUrl" || name === "bearerToken") {
			setSourceConnectionVerified(false);
			setSourceFieldsModified(true);
		}
		if (name === "targetUrl" || name === "username" || name === "password") {
			setTargetConnectionVerified(false);
			setTargetFieldsModified(true);
		}

		setAllData((prev) => ({
			...prev,
			[getTabName(activeTab)]: {
				...prev[getTabName(activeTab)],
				[name]: value,
			},
		}));

		if (name === "source" && value) {
			const authType =
				(value === "Intercom" && "Bearer") ||
				(value === "Tebra" && "Basic") ||
				"";
			setFormData((prev) => ({ ...prev, authType }));
			setAllData((prev) => ({
				...prev,
				[getTabName(activeTab)]: { ...prev[getTabName(activeTab)], authType },
			}));
		} else if (name === "target" && value) {
			const authType =
				(value === "Intercom" && "Bearer") ||
				(value === "Tebra" && "Basic") ||
				"";
			setFormData((prev) => ({ ...prev, authType }));
			setAllData((prev) => ({
				...prev,
				[getTabName(activeTab)]: { ...prev[getTabName(activeTab)], authType },
			}));
		}
		checkCurrentTabCompletion();
	};
*/

	const authTypeRequirements = {
		Bearer: ["url", "bearerToken"],
		Basic: ["url", "username", "password"],
		"OAuth 2.0": ["url", "clientId", "clientSecret", "grantType"],
		WSDL: ["url", "username", "password", "practiceName", "customerKey"],
	};

	const isFieldSensitive = (authType, fieldName, isSource) => {
		const requiredFields = authTypeRequirements[authType] || [];
		const prefix = isSource ? "source" : "target";

		return requiredFields.some((field) => {
			if (field === "url") return fieldName === `${prefix}Url`;
			return fieldName === field;
		});
	};

	const handleInputChange = (e) => {
		const { name, value } = e.target;

		setFormData((prev) => ({ ...prev, [name]: value }));

		// Reset connection verification flags when URLs or credentials change
		if (isFieldSensitive(formData.sourceAuthType, name, true)) {
			setSourceConnectionVerified(false);
			setSourceFieldsModified(true);
		}

		if (isFieldSensitive(formData.targetAuthType, name, false)) {
			setTargetConnectionVerified(false);
			setTargetFieldsModified(true);
		}

		// Save per-tab data
		setAllData((prev) => ({
			...prev,
			[getTabName(activeTab)]: {
				...prev[getTabName(activeTab)],
				[name]: value,
			},
		}));

		// Set authType based on selected source/target connector
		if (name === "source" && value) {
			const detectedType = connectorAuthTypes[value] || "";
			setFormData((prev) => ({
				...prev,
				authType: detectedType,
				sourceAuthType: detectedType,
			}));
		} else if (name === "target" && value) {
			const detectedType = connectorAuthTypes[value] || "";
			setFormData((prev) => ({
				...prev,
				authType: detectedType,
				targetAuthType: detectedType,
			}));
		}

		checkCurrentTabCompletion();
	};

	const handleFieldMappingChange = (tab, index, field, value) => {
		setFieldMappings((prev) => {
			const updatedTab = [...(prev[tab] || [])];
			updatedTab[index][field] = value;
			return { ...prev, [tab]: updatedTab };
		});
		setAllData((prev) => ({
			...prev,
			fieldMapping: { ...prev.fieldMapping, [tab]: fieldMappings[tab] },
		}));
		checkCurrentTabCompletion();
	};

	const handleAddRow = () => {
		const newRow = { source: "", target: "", datatype: "", remarks: "" };
		setFieldMappings((prev) => ({
			...prev,
			[activeFieldMappingTab]: [...(prev[activeFieldMappingTab] || []), newRow],
		}));
		checkCurrentTabCompletion();
	};

	const handleDeleteRow = (index) => {
		setFieldMappings((prev) => {
			const updatedTab = (prev[activeFieldMappingTab] || []).filter(
				(_, i) => i !== index
			);
			return { ...prev, [activeFieldMappingTab]: updatedTab };
		});
		checkCurrentTabCompletion();
	};

	useEffect(() => {
		if (isEditMode) return;

		const initialFieldMappings = {};
		Object.keys(extendedCategories).forEach((key) => {
			if (extendedCategories[key]) {
				initialFieldMappings[key] = [
					{
						source: "",
						target: "",
						datatype: "",
					},
				];
			}
		});
		setFieldMappings(initialFieldMappings);

		// Ensure activeFieldMappingTab is set to a valid key
		const firstEnabledCategory = Object.keys(initialFieldMappings)[0] || "";
		setActiveFieldMappingTab(firstEnabledCategory);
	}, [extendedCategories]);

	useEffect(() => {
		// In edit mode, if no active tab is selected and fieldMappings exist,
		// set the first available tab as active
		if (
			isEditMode &&
			Object.keys(fieldMappings).length > 0 &&
			!activeFieldMappingTab
		) {
			const firstAvailableTab = Object.keys(fieldMappings)[0];
			if (firstAvailableTab) {
				setActiveFieldMappingTab(firstAvailableTab);
			}
		}
	}, [isEditMode, fieldMappings, activeFieldMappingTab]);

	useEffect(() => {
		if (isEditMode && activeFieldMappingTab) {
			const fetchMappingOptions = async () => {
				try {
					const config1 = {
						method: "get",
						maxBodyLength: Infinity,
						url: `${
							config.baseURL
						}get-sg-middleware-mapping-objectsnew?source=${formData.source.toLowerCase()}&target=${formData.target.toLowerCase()}&plan_mapping_category_name=${activeFieldMappingTab}`,
						headers: {
							...config.headers,
						},
					};

					const response1 = await axios.request(config1);
					const data1 = response1.data;

					console.log(
						"fetchMappingOptions->Source options/:",
						data1.sourceOptions
					);
					console.log(
						"fetchMappingOptions->Target options/:",
						data1.targetOptions
					);

					setSourceOptions(data1.sourceOptions || []);
					setTargetOptions(data1.targetOptions || []);
				} catch (error) {
					console.error("Error loading mapping options in edit mode:", error);
				}
			};

			fetchMappingOptions();
		}
	}, [isEditMode, activeFieldMappingTab]);

	useEffect(() => {
		if (
			!isEditMode &&
			activeFieldMappingTab &&
			formData.source &&
			formData.target
		) {
			const fetchMappingOptions = async () => {
				try {
					const config1 = {
						method: "get",
						maxBodyLength: Infinity,
						url: `${
							config.baseURL
						}get-sg-middleware-mapping-objectsnew?source=${formData.source.toLowerCase()}&target=${formData.target.toLowerCase()}&plan_mapping_category_name=${activeFieldMappingTab}`,
						headers: {
							...config.headers,
						},
					};

					const response1 = await axios.request(config1);
					const data1 = response1.data;

					console.log(
						"fetchMappingOptions->Source options//:",
						data1.sourceOptions
					);
					console.log(
						"fetchMappingOptions->Target options//:",
						data1.targetOptions
					);

					setSourceOptions(data1.sourceOptions || []);
					setTargetOptions(data1.targetOptions || []);
				} catch (error) {
					console.error(
						"Error loading mapping options on initial tab create:",
						error
					);
				}
			};

			fetchMappingOptions();
		}
	}, [activeFieldMappingTab, isEditMode, formData.source, formData.target]);

	useEffect(() => {
		if (
			isEditMode &&
			Object.keys(fieldMappings).length > 0 &&
			!activeFieldMappingTab
		) {
			const firstAvailableTab = Object.keys(fieldMappings)[0];
			if (firstAvailableTab) {
				setActiveFieldMappingTab(firstAvailableTab);
			}
		}
	}, [isEditMode, fieldMappings, activeFieldMappingTab]);

	const handleCategoryToggle = (category, isEnabled) => {
		setExtendedCategories((prev) => ({
			...prev,
			[category]: isEnabled,
		}));
	};

	const getTabName = (tabIndex) => {
		switch (tabIndex) {
			case TAB_PLAN_DETAILS:
				return "planDetails";
			case TAB_SOURCE_CONNECTION:
				return "sourceConnection";
			case TAB_TARGET_CONNECTION:
				return "targetConnection";
			case TAB_FIELD_MAPPING:
				return "fieldMapping";
			default:
				return "";
		}
	};

	const isTabEnabled = (tabIndex) => {
		if (isEditMode) {
			return true;
		}

		const allTabsStatus = {
			[TAB_PLAN_DETAILS]: true,
			[TAB_SOURCE_CONNECTION]: tabStatus.planDetails,
			[TAB_TARGET_CONNECTION]:
				tabStatus.planDetails &&
				tabStatus.sourceConnection &&
				!sourceFieldsModified &&
				sourceConnectionVerified,
			[TAB_CATEGORIES]:
				tabStatus.planDetails &&
				tabStatus.sourceConnection &&
				tabStatus.targetConnection &&
				!sourceFieldsModified &&
				!targetFieldsModified &&
				sourceConnectionVerified &&
				targetConnectionVerified,
			[TAB_FIELD_MAPPING]:
				tabStatus.planDetails &&
				tabStatus.sourceConnection &&
				tabStatus.targetConnection &&
				tabStatus.categories &&
				!sourceFieldsModified &&
				!targetFieldsModified &&
				sourceConnectionVerified &&
				targetConnectionVerified,
		};

		return allTabsStatus[tabIndex] || false;
	};

	useEffect(() => {
		if (sourceFieldsModified || targetFieldsModified) {
			checkCurrentTabCompletion();
		}
	}, [sourceFieldsModified, targetFieldsModified]);

	// useEffect(() => {
	// 	setIsAnyCategorySelected(
	// 		Object.values(fieldMappings).some((mapping) => mapping.enabled)
	// 	);
	// }, [fieldMappings]);

	const testSourceConnection = async () => {
		setSourceTestLoading(true);
		try {
			let payload = {
				url: formData.sourceUrl,
				type: formData.sourceAuthType?.toLowerCase(), // "bearer", "basic", etc.
			};

			switch (formData.sourceAuthType) {
				case "Bearer":
					payload.bearerToken = formData.bearerToken;
					break;
				case "Basic":
					payload.username = formData.username;
					payload.password = formData.password;
					break;
				case "OAuth 2.0":
					payload.type = "client_credentials";
					payload.clientId = formData.clientId;
					payload.clientSecret = formData.clientSecret;
					payload.grantType = formData.grantType;
					break;
				case "WSDL":
					payload.type = "basic"; // ✅ Treat WSDL as Basic Auth
					payload.username = formData.username;
					payload.password = formData.password;
					payload.practiceName = formData.practiceName;
					payload.customerKey = formData.customerKey;
					break;
				default:
					break;
			}

			const response = await axios.post(
				`${config.baseURL}middleware-backend`,
				payload,
				{
					headers: {
						...config.headers,
					},
				}
			);

			console.log("middleware-backend response:", response.data);

			const isSuccessful = response.data === "success";
			setConnectionStatus(
				isSuccessful ? "Connection Successful" : "Connection Failed"
			);
			setSourceConnectionVerified(isSuccessful);
			setSourceFieldsModified(false);
			setLastTestedConnection("source");

			if (isSuccessful) {
				setTabStatus((prev) => ({ ...prev, sourceConnection: true }));
			}
			checkCurrentTabCompletion();
		} catch (error) {
			console.error("Error testing Source connection:", error);
			setConnectionStatus(
				"Connection Failed: " +
					(error.response?.data?.message || "An error occurred")
			);
			setSourceConnectionVerified(false);
			setLastTestedConnection("source");
			checkCurrentTabCompletion();
		} finally {
			setSourceTestLoading(false);
		}
	};

	const testTargetConnection = async () => {
		setTargetTestLoading(true);
		try {
			let payload = {
				url: formData.targetUrl,
				type: formData.targetAuthType?.toLowerCase(),
			};

			switch (formData.targetAuthType) {
				case "Bearer":
					payload.bearerToken = formData.bearerToken;
					break;
				case "Basic":
					payload.username = formData.username;
					payload.password = formData.password;
					break;
				case "OAuth 2.0":
					payload.clientId = formData.clientId;
					payload.clientSecret = formData.clientSecret;
					payload.grantType = formData.grantType;
					break;
				case "WSDL":
					payload.type = "basic"; // ✅ Treat WSDL as Basic Auth
					payload.username = formData.username;
					payload.password = formData.password;
					payload.practiceName = formData.practiceName;
					payload.customerKey = formData.customerKey;

					break;
				default:
					break;
			}

			const response = await axios.post(
				`${config.baseURL}middleware-backend`,
				payload,
				{
					headers: {
						...config.headers,
					},
				}
			);

			const isSuccessful = response.data === "success";
			setConnectionStatus(
				isSuccessful ? "Connection Successful" : "Connection Failed"
			);
			setTargetConnectionVerified(isSuccessful);
			setTargetFieldsModified(false);
			setLastTestedConnection("target");

			if (isSuccessful) {
				setTabStatus((prev) => ({ ...prev, targetConnection: true }));
			}
			checkCurrentTabCompletion();
		} catch (error) {
			console.error("Error testing Target connection:", error);
			setConnectionStatus(
				"Connection Failed: " +
					(error.response?.data?.message || "An error occurred")
			);
			setTargetConnectionVerified(false);
			setLastTestedConnection("target");
			checkCurrentTabCompletion();
		} finally {
			setTargetTestLoading(false);
		}
	};

	const checkCurrentTabCompletion = () => {
		switch (activeTab) {
			case TAB_PLAN_DETAILS:
				const isPlanDetailsComplete =
					!!formData.plan_name && !!formData.source && !!formData.target;
				setIsCurrentTabComplete(isPlanDetailsComplete);
				if (isPlanDetailsComplete) {
					setTabStatus((prev) => ({ ...prev, planDetails: true }));
				}
				break;
			case TAB_SOURCE_CONNECTION:
				let isSourceComplete = false;
				switch (formData.sourceAuthType) {
					case "Bearer":
						isSourceComplete =
							!!formData.sourceUrl &&
							!!formData.bearerToken &&
							sourceConnectionVerified &&
							!sourceFieldsModified;
						break;
					case "Basic":
						isSourceComplete =
							!!formData.sourceUrl &&
							!!formData.username &&
							!!formData.password &&
							sourceConnectionVerified &&
							!sourceFieldsModified;
						break;
					case "OAuth 2.0":
						isSourceComplete =
							!!formData.sourceUrl &&
							!!formData.clientId &&
							!!formData.clientSecret &&
							!!formData.grantType &&
							sourceConnectionVerified &&
							!sourceFieldsModified;
						break;
					case "WSDL":
						isSourceComplete =
							!!formData.sourceUrl &&
							!!formData.username &&
							!!formData.password &&
							!!formData.practiceName &&
							!!formData.customerKey &&
							sourceConnectionVerified &&
							!sourceFieldsModified;
						break;
					default:
						isSourceComplete = false;
				}

				setIsCurrentTabComplete(isSourceComplete);
				setTabStatus((prev) => ({
					...prev,
					sourceConnection: isSourceComplete,
				}));
				break;

			case TAB_TARGET_CONNECTION:
				let isTargetComplete = false;

				switch (formData.targetAuthType) {
					case "Bearer":
						isTargetComplete =
							!!formData.sourceUrl &&
							!!formData.bearerToken &&
							targetConnectionVerified &&
							!targetFieldsModified;
						break;
					case "Basic":
						isTargetComplete =
							!!formData.sourceUrl &&
							!!formData.username &&
							!!formData.password &&
							targetConnectionVerified &&
							!targetFieldsModified;
						break;
					case "OAuth 2.0":
						isTargetComplete =
							!!formData.sourceUrl &&
							!!formData.clientId &&
							!!formData.clientSecret &&
							!!formData.grantType &&
							targetConnectionVerified &&
							!targetFieldsModified;
						break;
					case "WSDL":
						isTargetComplete =
							!!formData.sourceUrl &&
							!!formData.username &&
							!!formData.password &&
							!!formData.practiceName &&
							!!formData.customerKey &&
							targetConnectionVerified &&
							!targetFieldsModified;
						break;
					default:
						isTargetComplete = false;
				}

				setIsCurrentTabComplete(isTargetComplete);
				setTabStatus((prev) => ({
					...prev,
					targetConnection: isTargetComplete,
				}));
				break;

			case TAB_CATEGORIES:
				const isCategoriesComplete = Object.values(extendedCategories).some(
					(isEnabled) => isEnabled
				);
				setIsCurrentTabComplete(isCategoriesComplete);
				if (isCategoriesComplete) {
					setTabStatus((prev) => ({ ...prev, categories: true }));
				} else {
					setTabStatus((prev) => ({ ...prev, categories: false }));
				}
				break;
			case TAB_FIELD_MAPPING:
				const isFieldMappingComplete = Object.values(fieldMappings).some(
					(mappings) => mappings.length > 0
				);
				setIsCurrentTabComplete(isFieldMappingComplete);
				if (isFieldMappingComplete) {
					setTabStatus((prev) => ({ ...prev, fieldMapping: true }));
				}
				break;
			default:
				setIsCurrentTabComplete(false);
		}
	};

	const setupDefaultFieldMappingTab = async () => {
		// Use the previously selected tab if available, otherwise use the first enabled category
		let categoryToUse = activeFieldMappingTab;
		if (!categoryToUse) {
			const enabledCategories = Object.keys(extendedCategories).filter(
				(cat) => extendedCategories[cat]
			);
			categoryToUse = enabledCategories[0];
		}
		if (categoryToUse) {
			try {
				const config1 = {
					method: "get",
					maxBodyLength: Infinity,
					url: `${
						config.baseURL
					}get-sg-middleware-mapping-objectsnew?source=${formData.source.toLowerCase()}&target=${formData.target.toLowerCase()}&plan_mapping_category_name=${categoryToUse}`,
					headers: {
						...config.headers,
					},
				};
				const mappingObjectsResponse = await axios.request(config1);
				const data1 = mappingObjectsResponse.data;
				setSourceOptions(data1.sourceOptions || []);
				setTargetOptions(data1.targetOptions || []);
				setActiveFieldMappingTab(categoryToUse);
			} catch (err) {
				console.error(
					"Error fetching mapping options for selected category in setupDefaultFieldMappingTab:",
					err
				);
			}
		}
	};

	const handleCreatePlan = async () => {
		if (activeTab < TAB_FIELD_MAPPING) {
			// Show alert if moving to Field Mapping tab
			if (activeTab + 1 === TAB_FIELD_MAPPING) {
				setupDefaultFieldMappingTab();
			}
			if (activeTab == TAB_PLAN_DETAILS) {
				const config1 = {
					method: "get",
					maxBodyLength: Infinity,
					url: `${
						config.baseURL
					}get-sg-middleware-mapping-objectsnew?source=${formData.source.toLowerCase()}&target=${formData.target.toLowerCase()}&plan_mapping_category_name=${activeFieldMappingTab}`,
					headers: {
						...config.headers,
					},
				};

				const mappingObjectsResponse = await axios.request(config1);
				const data1 = mappingObjectsResponse.data; // Axios automatically parses JSON

				// Ensure response contains sourceOptions and targetOptions
				const sourceOptionsData1 = data1.sourceOptions;
				const targetOptionsData1 = data1.targetOptions;

				console.log("handleCreatePlan->Source options/:", sourceOptionsData1);
				console.log("handleCreatePlan->Target options/:", targetOptionsData1);

				setSourceOptions(sourceOptionsData1 || []);
				setTargetOptions(targetOptionsData1 || []);
				// console.log(sourceOptions);
				// console.log(targetOptions);
			}
			// Only proceed to next tab if current tab is complete
			if (isCurrentTabComplete) {
				setActiveTab(activeTab + 1);
			}
			return;
		}
		setLoading(true);
		setError(null);

		try {
			// Step 1: Create plan
			const planRequestBody = {
				plan_name: formData.plan_name,
				source: formData.source,
				target: formData.target,
				status: "active",
				user_id: String(userId),
			};

			console.log("Creating plan with data:", planRequestBody);

			const planResponse = await axios.post(
				`${config.baseURL}middlewarePlans`,
				planRequestBody,
				{
					headers: {
						...config.headers,
					},
				}
			);

			const planId = planResponse.data.upsertedId;
			console.log("Generated Plan ID:", planId);

			if (!planId) {
				throw new Error("No plan ID received from the server");
			}

			// Step 2: Create plan connections
			const currentTimestamp = new Date().toISOString();
			const encodedCredentials = btoa(
				`${formData.username}:${formData.password}`
			);

			const connectionsRequestBody = {
				plan_id: planId,
				source_uri: formData.sourceUrl,
				target_uri: formData.targetUrl,
				source_api_token: formData.bearerToken,
				target_api_token: encodedCredentials, // Store encoded credentials here
				created_at: currentTimestamp,
				updated_at: currentTimestamp,
				source_auth_type: formData.sourceAuthType || "", // ✅ save source auth type
				target_auth_type: formData.targetAuthType || "", // ✅ save target auth type
				other_target_details: {
					practiceName: formData.practiceName,
					customerKey: formData.customerKey,
					clientId: formData.clientId,
					clientSecret: formData.clientSecret,
					grantType: formData.grantType,
				},
			};
			console.log(
				"Creating plan connections with data:",
				connectionsRequestBody
			);

			const connectionsResponse = await axios.post(
				`${config.baseURL}middlewarePlanconnections`,
				connectionsRequestBody,
				{
					headers: {
						...config.headers,
					},
				}
			);

			if (!connectionsResponse.data) {
				throw new Error("Failed to create plan connections");
			}

			console.log("handleCreatePlan");

			console.log({ fieldMappings: fieldMappings });

			// Step 3: Create field mappings
			for (const [category, mappings] of Object.entries(fieldMappings)) {
				if (mappings.length > 0) {
					const mappingRequestBody = {
						plan_id: planId,
						plan_mapping_category_id: category === "Patient Details" ? 1 : 2,
						plan_mapping_category_name: category,
						created_at: currentTimestamp,
						updated_at: currentTimestamp,
						fieldMappings: mappings.map((mapping) => ({
							source_field: mapping.source,
							target_field: mapping.target,
							target_datatype: mapping.datatype,
							mapping_remarks: mapping.remarks || "",
							// created_at: currentTimestamp,
							// updated_at: currentTimestamp
						})),
					};

					console.log(`Creating field mappings for ${category}`);

					console.log({ mappingRequestBody: mappingRequestBody });

					await axios.post(
						`${config.baseURL}middlewarePlanmappings`,
						mappingRequestBody,
						{
							headers: {
								...config.headers,
							},
						}
					);
				}
			}

			setSuccessMessage("Plan created successfully!");
			setTimeout(() => {
				setSuccessMessage("");
				navigate("/plan-management");
			}, 3000);
		} catch (error) {
			console.error("Error during submission:", error);
			let errorMessage = "An unexpected error occurred";

			if (axios.isAxiosError(error)) {
				console.error("API Error Response:", error.response?.data);
				errorMessage = error.response?.data?.message || error.message;
			}

			setError(errorMessage);
			alert(`Error: ${errorMessage}`);
		} finally {
			setLoading(false);
		}
	};

	const handleEditPlan = async () => {
		if (activeTab < TAB_FIELD_MAPPING) {
			// If not on the last tab, just move to next tab
			if (isCurrentTabComplete) {
				setActiveTab(activeTab + 1);
			}
			return;
		}

		// Only proceed with update if on the last tab
		setLoading(true);
		setError(null);

		try {
			// Convert plan_id to number before sending
			const numericPlanId = parseInt(editingPlanId, 10);

			// Update plan details using PATCH
			const planRequestBody = {
				plan_name: formData.plan_name,
				source: formData.source,
				target: formData.target,
				status: "active",
				user_id: String(userId),
			};

			await axios.patch(
				`${config.baseURL}middlewarePlans/${numericPlanId}`,
				planRequestBody,
				{
					headers: {
						...config.headers,
					},
				}
			);

			// Update plan connections using PATCH with numeric plan_id
			const encodedCredentials = btoa(
				`${formData.username}:${formData.password}`
			);

			const connectionsRequestBody = {
				plan_id: numericPlanId,
				source_uri: formData.sourceUrl,
				target_uri: formData.targetUrl,
				source_api_token: formData.bearerToken,
				target_api_token: encodedCredentials, // Store encoded credentials
				updated_at: new Date().toISOString(),
				source_auth_type: formData.sourceAuthType || formData.authType,
				target_auth_type: formData.targetAuthType || formData.authType,
				other_target_details: {
					practiceName: formData.practiceName,
					customerKey: formData.customerKey,
					clientId: formData.clientId,
					clientSecret: formData.clientSecret,
					grantType: formData.grantType,
				},
			};

			await axios.patch(
				`${config.baseURL}middlewarePlanconnections/${connectionId}`,
				connectionsRequestBody,
				{
					headers: {
						...config.headers,
					},
				}
			);

			let i = 0;
			// Update field mappings using PATCH with numeric plan_id
			console.log("edit Field Mappings:", fieldMappings);
			for (const [category, mappings] of Object.entries(fieldMappings)) {
				// Only process if extendedCategories[category] is true
				if (extendedCategories[category] && mappings.length > 0) {
					const mappingRequestBody = {
						plan_id: numericPlanId, // Changed to number
						plan_mapping_category_id: category === "Patient Details" ? 1 : 2,
						plan_mapping_category_name: category,
						updated_at: new Date().toISOString(),
						fieldMappings: mappings.map((mapping) => ({
							source_field: mapping.source,
							target_field: mapping.target,
							target_datatype: mapping.datatype,
							mapping_remarks: mapping.remarks || "",
						})),
					};

					const mappingIdNumber = mappingId[i];

					console.log({ mappingRequestBody: mappingRequestBody });
					console.log("handleEditPlan->missingCategories", missingCategories);

					if (missingCategories.includes(category)) {
						console.log("Creating new mapping: ", category);
						await axios.post(
							`${config.baseURL}middlewarePlanmappings`,
							mappingRequestBody,
							{
								headers: {
									...config.headers,
								},
							}
						);
					} else {
						console.log("Updating existing mapping: ", category);
						await axios.patch(
							`${config.baseURL}middlewarePlanmappings/${mappingIdNumber}`,
							mappingRequestBody,
							{
								headers: {
									...config.headers,
								},
							}
						);
					}
				}
				i++;
			}

			setSuccessMessage("Plan updated successfully!");
			setTimeout(() => {
				setSuccessMessage("");
				navigate("/plan-management");
			}, 3000);
		} catch (error) {
			console.error("Error during update:", error);
			let errorMessage = "An unexpected error occurred";

			if (axios.isAxiosError(error)) {
				console.error("API Error Response:", error.response?.data);
				errorMessage = error.response?.data?.message || error.message;
			}

			setError(errorMessage);
			alert(`Error: ${errorMessage}`);
		} finally {
			setLoading(false);
		}
	};

	const renderFieldMappingTable = () => {
		const rows = Array.isArray(fieldMappings[activeFieldMappingTab])
			? fieldMappings[activeFieldMappingTab]
			: []; // Ensure rows is always an array

		const datatypeOptions = ["string", "number", "date"];

		const getUsedTargetFields = (currentIndex) => {
			return rows.reduce((acc, row, index) => {
				if (index !== currentIndex && row.target) {
					acc.push(row.target);
				}
				return acc;
			}, []);
		};

		const getAvailableTargetOptions = (currentIndex) => {
			const usedTargets = getUsedTargetFields(currentIndex);
			return targetOptions.filter((option) => !usedTargets.includes(option));
		};

		const handleFieldMappingChangeWithValidation = (
			tab,
			index,
			field,
			value
		) => {
			if (field === "target") {
				const usedTargets = getUsedTargetFields(index);
				if (usedTargets.includes(value)) {
					alert(
						"This target field is already mapped. Please select a different target field."
					);
					return;
				}
			}
			handleFieldMappingChange(tab, index, field, value);
		};

		const CustomPopper = (props) => (
			<Popper
				{...props}
				placement="bottom-start"
				modifiers={[{ name: "offset", options: { offset: [0, 5] } }]}
			>
				<Paper
					sx={{
						minWidth: "300px", // ✅ Increase dropdown options width here!
						maxWidth: "500px", // Optional: Max width if needed
						overflow: "auto",
					}}
				>
					{props.children}
				</Paper>
			</Popper>
		);

		return (
			<Box sx={{ width: "100%" }}>
				{rows.length === 0 ? (
					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
							gap: 2,
							py: 4,
						}}
					>
						<Typography color="textSecondary">No mappings found</Typography>
						<IconButton
							onClick={handleAddRow}
							sx={{
								backgroundColor: "#f5f5f5",
								"&:hover": { backgroundColor: "#e0e0e0" },
							}}
						>
							<AddIcon />
						</IconButton>
					</Box>
				) : (
					<TableContainer
						component={Paper}
						sx={{ width: "100%", overflowX: "auto" }}
					>
						<Table sx={{ minWidth: 1200, width: "100%" }}>
							<TableHead>
								<TableRow>
									{[
										"Source Fields",
										"Target Fields",
										"Datatype",
										"Remarks",
										"Actions",
									].map((heading, idx, arr) => (
										<TableCell
											key={heading}
											sx={{
												fontWeight: "bold",
												width:
													heading === "Source Fields" ||
													heading === "Target Fields"
														? "32%"
														: heading === "Actions"
														? 120
														: heading === "Datatype"
														? "14%"
														: "22%",
											}}
										>
											<Box
												sx={{
													display: "flex",
													alignItems: "center",
													justifyContent:
														heading === "Actions"
															? "space-between"
															: "flex-start",
												}}
											>
												{heading}
												{heading === "Actions" && (
													<IconButton
														size="small"
														onClick={handleAddRow}
														sx={{ ml: 1 }}
													>
														<AddIcon />
													</IconButton>
												)}
											</Box>
										</TableCell>
									))}
								</TableRow>
							</TableHead>
							<TableBody>
								{rows.map((row, index) => (
									<TableRow key={index}>
										<TableCell sx={{ width: "32%" }}>
											<Autocomplete
												freeSolo
												options={sourceOptions}
												value={row.source || ""}
												PopperComponent={CustomPopper}
												onChange={(event, newValue) =>
													handleFieldMappingChangeWithValidation(
														activeFieldMappingTab,
														index,
														"source",
														newValue || ""
													)
												}
												renderOption={(props, option) => (
													<Tooltip title={option}>
														<Box
															component="li"
															{...props}
															sx={{
																whiteSpace: "nowrap",
																overflow: "hidden",
																textOverflow: "ellipsis",
															}}
														>
															{option}
														</Box>
													</Tooltip>
												)}
												renderInput={(params) => (
													<TextField
														{...params}
														label="Select Source Field"
														variant="outlined"
														size="small"
														fullWidth
													/>
												)}
												isOptionEqualToValue={(option, value) =>
													option === value
												}
											/>
										</TableCell>
										<TableCell sx={{ width: "32%" }}>
											<Autocomplete
												freeSolo
												options={targetOptions}
												value={row.target || ""}
												PopperComponent={CustomPopper}
												onChange={(event, newValue) =>
													handleFieldMappingChangeWithValidation(
														activeFieldMappingTab,
														index,
														"target",
														newValue || ""
													)
												}
												renderOption={(props, option) => (
													<Tooltip title={option}>
														<Box
															component="li"
															{...props}
															sx={{
																whiteSpace: "nowrap",
																overflow: "hidden",
																textOverflow: "ellipsis",
															}}
														>
															{option}
														</Box>
													</Tooltip>
												)}
												renderInput={(params) => (
													<TextField
														{...params}
														label="Select Target Field"
														variant="outlined"
														size="small"
														fullWidth
														placeholder="Type or select target"
													/>
												)}
												isOptionEqualToValue={(option, value) =>
													option === value
												}
											/>
										</TableCell>
										<TableCell sx={{ width: "14%" }}>
											<CustomSelect
												value={row.datatype}
												onChange={(e) =>
													handleFieldMappingChangeWithValidation(
														activeFieldMappingTab,
														index,
														"datatype",
														e.target.value
													)
												}
												options={datatypeOptions}
												placeholder="Select Datatype"
											/>
										</TableCell>
										<TableCell sx={{ width: "22%" }}>
											<TextField
												placeholder="Add comments or custom rules"
												variant="outlined"
												size="small"
												fullWidth
												value={row.remarks}
												onChange={(e) =>
													handleFieldMappingChangeWithValidation(
														activeFieldMappingTab,
														index,
														"remarks",
														e.target.value
													)
												}
											/>
										</TableCell>
										<TableCell sx={{ width: 120 }}>
											<IconButton onClick={() => handleDeleteRow(index)}>
												<RemoveIcon />
											</IconButton>
										</TableCell>
									</TableRow>
								))}
							</TableBody>
						</Table>
					</TableContainer>
				)}
			</Box>
		);
	};

	// Add these handler functions
	const handleClickShowBearerToken = () => setShowBearerToken((show) => !show);
	const handleClickShowPassword = () => setShowPassword((show) => !show);

	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};

	const availableTabs = Object.keys(fieldMappings).filter((tab) =>
		isEditMode
			? extendedCategories[tab] ||
			  (Array.isArray(fieldMappings[tab]) &&
					fieldMappings[tab].some((f) => f.source || f.target || f.datatype))
			: extendedCategories[tab]
	);

	useEffect(() => {
		if (isEditMode && !activeFieldMappingTab && availableTabs.length > 0) {
			const defaultTab = availableTabs[0];
			setActiveFieldMappingTab(defaultTab);
			handleFieldMappingTabChangeEdit(defaultTab); // 💡 Auto-load dropdowns and mappings
		}
	}, [isEditMode, activeFieldMappingTab, availableTabs]);

	const renderFormFields = () => {
		switch (activeTab) {
			case TAB_PLAN_DETAILS:
				return (
					<>
						<TextField
							label="Plan Name"
							variant="outlined"
							fullWidth
							margin="normal"
							name="plan_name"
							value={formData.plan_name}
							onChange={handleInputChange}
						/>
						<TextField
							select
							label="Source"
							variant="outlined"
							fullWidth
							margin="normal"
							name="source"
							value={formData.source}
							onChange={handleInputChange}
						>
							{sources.map((source) => (
								<MenuItem key={source} value={source}>
									{source}
								</MenuItem>
							))}
						</TextField>
						<TextField
							select
							label="Target"
							variant="outlined"
							fullWidth
							margin="normal"
							name="target"
							value={formData.target}
							onChange={handleInputChange}
						>
							{targets.map((target) => (
								<MenuItem key={target} value={target}>
									{target}
								</MenuItem>
							))}
						</TextField>
					</>
				);
			case TAB_SOURCE_CONNECTION:
				return (
					<>
						<TextField
							label="Auth Type"
							select
							fullWidth
							margin="normal"
							name="sourceAuthType"
							value={formData.sourceAuthType}
							onChange={handleInputChange}
						>
							{authTypes.map((type) => (
								<MenuItem key={type} value={type}>
									{type}
								</MenuItem>
							))}
						</TextField>

						<TextField
							label="Source URL"
							variant="outlined"
							fullWidth
							margin="normal"
							name="sourceUrl"
							value={formData.sourceUrl}
							onChange={handleInputChange}
						/>

						{formData.sourceAuthType === "Bearer" && (
							<TextField
								label="Bearer Token"
								variant="outlined"
								fullWidth
								margin="normal"
								name="bearerToken"
								type={showBearerToken ? "text" : "password"}
								value={formData.bearerToken}
								onChange={handleInputChange}
								InputProps={{
									endAdornment: (
										<InputAdornment position="end">
											<IconButton
												onClick={handleClickShowBearerToken}
												onMouseDown={handleMouseDownPassword}
												edge="end"
											>
												{showBearerToken ? <VisibilityOff /> : <Visibility />}
											</IconButton>
										</InputAdornment>
									),
								}}
							/>
						)}

						{formData.sourceAuthType === "Basic" && (
							<>
								<TextField
									label="Username"
									variant="outlined"
									fullWidth
									margin="normal"
									name="username"
									value={formData.username}
									onChange={handleInputChange}
								/>
								<TextField
									label="Password"
									variant="outlined"
									fullWidth
									margin="normal"
									name="password"
									type={showPassword ? "text" : "password"}
									value={formData.password}
									onChange={handleInputChange}
									InputProps={{
										endAdornment: (
											<InputAdornment position="end">
												<IconButton
													onClick={handleClickShowPassword}
													onMouseDown={handleMouseDownPassword}
													edge="end"
												>
													{showPassword ? <VisibilityOff /> : <Visibility />}
												</IconButton>
											</InputAdornment>
										),
									}}
								/>
							</>
						)}

						{formData.sourceAuthType === "OAuth 2.0" && (
							<>
								<TextField
									label="Client ID"
									fullWidth
									margin="normal"
									name="clientId"
									value={formData.clientId || ""}
									onChange={handleInputChange}
								/>
								<TextField
									label="Client Secret"
									fullWidth
									margin="normal"
									type="password"
									name="clientSecret"
									value={formData.clientSecret || ""}
									onChange={handleInputChange}
								/>
								<TextField
									label="Grant Type"
									fullWidth
									margin="normal"
									name="grantType"
									value={formData.grantType || ""}
									onChange={handleInputChange}
								/>
								{/* Add redirectUri, scopes, etc., if needed */}
							</>
						)}

						{formData.sourceAuthType === "WSDL" && (
							<>
								<TextField
									label="Username"
									variant="outlined"
									fullWidth
									margin="normal"
									name="username"
									value={formData.username}
									onChange={handleInputChange}
								/>
								<TextField
									label="Password"
									variant="outlined"
									fullWidth
									margin="normal"
									name="password"
									type={showPassword ? "text" : "password"}
									value={formData.password}
									onChange={handleInputChange}
									InputProps={{
										endAdornment: (
											<InputAdornment position="end">
												<IconButton
													onClick={handleClickShowPassword}
													onMouseDown={handleMouseDownPassword}
													edge="end"
												>
													{showPassword ? <VisibilityOff /> : <Visibility />}
												</IconButton>
											</InputAdornment>
										),
									}}
								/>
								<TextField
									label="Practice Name"
									variant="outlined"
									fullWidth
									margin="normal"
									name="practiceName"
									value={formData.practiceName || ""}
									onChange={handleInputChange}
								/>
								<TextField
									label="Customer Key"
									variant="outlined"
									fullWidth
									margin="normal"
									name="customerKey"
									value={formData.customerKey || ""}
									onChange={handleInputChange}
								/>
							</>
						)}

						<Button
							variant="contained"
							color="primary"
							sx={{ marginTop: 2 }}
							onClick={testSourceConnection}
						>
							Test Source Connection
						</Button>

						{lastTestedConnection === "source" && connectionStatus && (
							<Alert
								severity={
									connectionStatus.includes("Successful") ? "success" : "error"
								}
								style={{ marginTop: "15px" }}
							>
								{connectionStatus}
							</Alert>
						)}
					</>
				);

			case TAB_TARGET_CONNECTION:
				return (
					<>
						<TextField
							label="Auth Type"
							select
							fullWidth
							margin="normal"
							name="targetAuthType"
							value={formData.targetAuthType}
							onChange={handleInputChange}
						>
							{authTypes.map((type) => (
								<MenuItem key={type} value={type}>
									{type}
								</MenuItem>
							))}
						</TextField>

						<TextField
							label="Target URL"
							variant="outlined"
							fullWidth
							margin="normal"
							name="targetUrl"
							value={formData.targetUrl}
							onChange={handleInputChange}
						/>

						{formData.targetAuthType === "Bearer" && (
							<TextField
								label="Bearer Token"
								variant="outlined"
								fullWidth
								margin="normal"
								name="bearerToken"
								type={showBearerToken ? "text" : "password"}
								value={formData.bearerToken}
								onChange={handleInputChange}
								InputProps={{
									endAdornment: (
										<InputAdornment position="end">
											<IconButton
												onClick={handleClickShowBearerToken}
												onMouseDown={handleMouseDownPassword}
												edge="end"
											>
												{showBearerToken ? <VisibilityOff /> : <Visibility />}
											</IconButton>
										</InputAdornment>
									),
								}}
							/>
						)}

						{formData.targetAuthType === "Basic" && (
							<>
								<TextField
									label="Username"
									variant="outlined"
									fullWidth
									margin="normal"
									name="username"
									value={formData.username}
									onChange={handleInputChange}
								/>
								<TextField
									label="Password"
									variant="outlined"
									fullWidth
									margin="normal"
									name="password"
									type={showPassword ? "text" : "password"}
									value={formData.password}
									onChange={handleInputChange}
									InputProps={{
										endAdornment: (
											<InputAdornment position="end">
												<IconButton
													onClick={handleClickShowPassword}
													onMouseDown={handleMouseDownPassword}
													edge="end"
												>
													{showPassword ? <VisibilityOff /> : <Visibility />}
												</IconButton>
											</InputAdornment>
										),
									}}
								/>
							</>
						)}

						{formData.targetAuthType === "OAuth 2.0" && (
							<>
								<TextField
									label="Client ID"
									fullWidth
									margin="normal"
									name="clientId"
									value={formData.clientId || ""}
									onChange={handleInputChange}
								/>
								<TextField
									label="Client Secret"
									fullWidth
									margin="normal"
									type="password"
									name="clientSecret"
									value={formData.clientSecret || ""}
									onChange={handleInputChange}
								/>
								<TextField
									label="Grant Type"
									fullWidth
									margin="normal"
									name="grantType"
									value={formData.grantType || ""}
									onChange={handleInputChange}
								/>
							</>
						)}

						{formData.targetAuthType === "WSDL" && (
							<>
								<TextField
									label="Username"
									fullWidth
									margin="normal"
									name="username"
									value={formData.username}
									onChange={handleInputChange}
								/>
								<TextField
									label="Password"
									fullWidth
									margin="normal"
									type="password"
									name="password"
									value={formData.password}
									onChange={handleInputChange}
									InputProps={{
										endAdornment: (
											<InputAdornment position="end">
												<IconButton
													onClick={handleClickShowPassword}
													onMouseDown={handleMouseDownPassword}
													edge="end"
												>
													{showPassword ? <VisibilityOff /> : <Visibility />}
												</IconButton>
											</InputAdornment>
										),
									}}
								/>
								<TextField
									label="Practice Name"
									variant="outlined"
									fullWidth
									margin="normal"
									name="practiceName"
									value={formData.practiceName || ""}
									onChange={handleInputChange}
								/>
								<TextField
									label="Customer Key"
									variant="outlined"
									fullWidth
									margin="normal"
									name="customerKey"
									value={formData.customerKey || ""}
									onChange={handleInputChange}
								/>
							</>
						)}

						<Button
							variant="contained"
							color="primary"
							sx={{ marginTop: 2 }}
							onClick={testTargetConnection}
						>
							Test Target Connection
						</Button>

						{lastTestedConnection === "target" && connectionStatus && (
							<Alert
								severity={
									connectionStatus.includes("Successful") ? "success" : "error"
								}
								style={{ marginTop: "15px" }}
							>
								{connectionStatus}
							</Alert>
						)}
					</>
				);
			case TAB_CATEGORIES:
				return (
					<Box sx={{ padding: 3 }}>
						<Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>
							Select Categories
						</Typography>
						<Typography
							variant="body1"
							color="textSecondary"
							sx={{ marginBottom: 3 }}
						>
							Please select the categories you want to include in the mapping
							process.
						</Typography>
						<Box
							sx={{
								display: "grid",
								gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
								gap: 2,
							}}
						>
							{categories.map((category, index) => (
								<Box
									key={index}
									sx={{
										display: "flex",
										alignItems: "center",
										justifyContent: "space-between",
										padding: 2,
										border: "1px solid #e0e0e0",
										borderRadius: 2,
										boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
										backgroundColor: "#fafafa",
									}}
								>
									<Typography variant="body1" sx={{ fontWeight: "500" }}>
										{category}
									</Typography>
									<Switch
										checked={
											extendedCategories[category] ||
											(isEditMode &&
												Array.isArray(fieldMappings[category]) &&
												fieldMappings[category].some(
													(field) =>
														field.source || field.target || field.datatype // ✅ check if mapping actually exists
												))
										}
										onChange={async (e) => {
											const isChecked = e.target.checked;

											if (isEditMode) {
												// 🧠 Edit Mode: check if category already saved or not
												try {
													const res = await axios.get(
														`${config.baseURL}middlewarePlanmappings?query=plan_id:${editingPlanId}`,
														{
															headers: {
																...config.headers,
															},
														}
													);

													const savedCategories = res.data.map(
														(item) => item.plan_mapping_category_name
													);

													if (savedCategories.includes(category)) {
														// ✅ Already saved: fetch and show mapping
														const found = res.data.find(
															(item) =>
																item.plan_mapping_category_name === category
														);

														setFieldMappings((prev) => ({
															...prev,
															[category]: found.fieldMappings.map((f) => ({
																source: f.source_field || "",
																target: f.target_field || "",
																datatype: f.target_datatype || "",
																remarks: f.mapping_remarks || "",
															})),
														}));

														setActiveFieldMappingTab(category);
														handleFieldMappingTabChangeEdit(category);
													} else {
														// ✨ New selection in Edit Mode — create empty row

														handleCategoryToggle(category, isChecked);

														if (isChecked) {
															setFieldMappings((prev) => ({
																...prev,
																[category]: [
																	{
																		source: "",
																		target: "",
																		datatype: "",
																		remarks: "",
																	},
																],
															}));
															setActiveFieldMappingTab(category);
														}
													}
												} catch (err) {
													console.error(
														"❌ Error in edit mode category toggle:",
														err
													);
												}
											} else {
												// ✨ New Mode (Plan Creation): allow normal toggle and init mapping
												handleCategoryToggle(category, isChecked);

												if (isChecked) {
													setFieldMappings((prev) => ({
														...prev,
														[category]: [
															{
																source: "",
																target: "",
																datatype: "",
																remarks: "",
															},
														],
													}));
													setActiveFieldMappingTab(category);
												}
											}
										}}
										color="primary"
									/>
								</Box>
							))}
						</Box>
						{Object.values(extendedCategories).every(
							(isEnabled) => !isEnabled
						) && (
							<Typography
								color="error"
								variant="body2"
								sx={{
									marginTop: 2,
									textAlign: "center",
									fontWeight: "bold",
								}}
							>
								At least one category must be selected.
							</Typography>
						)}
						{console.log({ extendedCategories: extendedCategories })}
					</Box>
				);
			case TAB_FIELD_MAPPING:
				return (
					<>
						<Tabs
							value={activeFieldMappingTab || availableTabs[0]}
							onChange={(e, tab) =>
								isEditMode
									? handleFieldMappingTabChangeEdit(tab)
									: handleFieldMappingTabChange(tab)
							}
							indicatorColor="primary"
							textColor="primary"
						>
							{Object.keys(fieldMappings)
								.filter((tab) =>
									isEditMode
										? extendedCategories[tab] ||
										  (Array.isArray(fieldMappings[tab]) &&
												fieldMappings[tab].some(
													(f) => f.source || f.target || f.datatype
												))
										: extendedCategories[tab]
								)
								.map((tab) => (
									<Tab key={tab} label={tab} value={tab} />
								))}
						</Tabs>
						{renderFieldMappingTable()}
					</>
				);
			default:
				return null;
		}
	};

	useEffect(() => {
		checkCurrentTabCompletion();
	}, [
		formData,
		activeTab,
		sourceConnectionVerified,
		targetConnectionVerified,
		fieldMappings,
		extendedCategories,
	]);

	const handleBackButtonClick = () => {
		if (activeTab === TAB_PLAN_DETAILS) {
			navigate("/plan-management");
		} else {
			setActiveTab(activeTab - 1);
		}
	};
	return (
		<Box sx={{ width: "80%", margin: "20px auto", padding: "20px" }}>
			<Tabs
				value={activeTab}
				onChange={handleTabChange}
				indicatorColor="primary"
				textColor="primary"
			>
				<Tab label="Plan Details" disabled={!isTabEnabled(TAB_PLAN_DETAILS)} />
				<Tab
					label="Source Connection"
					disabled={!isTabEnabled(TAB_SOURCE_CONNECTION)}
				/>
				<Tab
					label="Target Connection"
					disabled={!isTabEnabled(TAB_TARGET_CONNECTION)}
				/>
				<Tab label="Categories" disabled={!isTabEnabled(TAB_CATEGORIES)} />
				<Tab
					label="Field Mapping"
					disabled={!isTabEnabled(TAB_FIELD_MAPPING)}
				/>
			</Tabs>
			<Box sx={{ mt: 2 }}>{renderFormFields()}</Box>
			<Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
				<Button
					variant="outlined"
					color="secondary"
					onClick={handleBackButtonClick}
				>
					Back
				</Button>
				<Button
					variant="contained"
					sx={{ backgroundColor: "#FF7600", color: "#2c2d2d" }}
					onClick={isEditMode ? handleEditPlan : handleCreatePlan}
					disabled={!isCurrentTabComplete}
				>
					<strong>
						{activeTab === TAB_FIELD_MAPPING
							? isEditMode
								? "Update Plan"
								: "Create Plan"
							: "Next"}
					</strong>
				</Button>
			</Box>
			{successMessage && (
				<Typography
					sx={{
						color: "green",
						textAlign: "center",
						mt: 2,
					}}
				>
					{successMessage}
				</Typography>
			)}
		</Box>
	);
};

export default ConnectionDetails;
